<template>
  <v-app>
    <transition mode="out-in">
      <router-view />
    </transition>
    <the-snackbar />
    <v-overlay :absolute="true" :value="0.46" v-if="$store.state.app.loading">
      <v-progress-circular size="64" indeterminate>
      </v-progress-circular>
    </v-overlay>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  components: {
    'the-snackbar': () => import('@/components/SnackBar.vue')
  }
}

</script>
